/**
 * What makes a STORED course publishable and sellable: it has at least one lesson — the
 * frontend mirror of `backend/modules/course_rules.py` (BUG-181).
 *
 * A lesson counts when it has an id. Every lesson written through the server's `Lesson`
 * model has one, but a legacy row may hold a lesson stored without it; the server counts
 * that as no lesson (the storefront answers `unpayable_reason: "no_lessons"`, Global Learn
 * lists the course under `published_without_lessons`), so a screen describing the stored
 * course must count it the same way, or the two disagree about one row.
 *
 * This answers a question about a course AS STORED. It is not the authoring rule: a save
 * is judged on its payload (`learn_telehealth_routes._refuse_empty_published`
 * counts the lessons sent), and the server mints an id for every lesson that arrives
 * without one, so saving an id-less lesson turns it into a real one.
 *
 * Pure, no imports.
 */

/** The ids of a course's lessons, in course order. Truthiness, like the server's
 *  `ls.get("id")`: an absent, null or empty id is no id. */
export function courseLessonIds(course) {
  const lessons = Array.isArray(course?.lessons) ? course.lessons : [];
  return lessons.filter((ls) => ls && ls.id).map((ls) => ls.id);
}

export function courseHasLessons(course) {
  return courseLessonIds(course).length >= 1;
}
